const ApiAttributesKeys = {
  readingNameKey: 'readingName',
  freeQuestionCountKey: 'TotalFreeQuestion',
  TotalNotesCountKey: 'TotalNotes',
  chapterIdKey: 'chapter_no',
  chapterNameKey: 'chapter_name',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Notes/ReadingList/ApiAttributesKays.js